//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import { constant } from "../../common/publicConstant";
import YtoRate from "../../components/yto-rate";
import waybillnosList from "./waybillnosList";
import {
    pullMessage,
    postMessage,
    closeSession,
    getHistory,
    getSession,
    authSession,
    fastTrackEntranceCount,
    trackManual,
    getLink,
    xiaoChat,
    getStatus
} from "../../service/service";
import {
    // imageUpload,
    imageDownload
} from "../../service/uploadService";
import { formatDate } from "../../service/date";
import { setTimeout } from "timers";
import common from "@/common/common";
import YtoModal from "../../components/yto-modal.vue";
let timer = null;
let xiaoIProblemLinks = []; // xiaoI问题列表
export default {
    name: "new-chat",
    components: {
        YtoModal,
        waybillnosList,
        YtoRate
    },
    data() {
        return {
            phoneNumber: "", // 手机号码
            validPhone: "", // 校验手机号消息
            handleWaybillNo: "", // 手动输入的运单号
            validWaybillNo: "", // 校验运单号消息
            handleorderNo: "", // 手动输入的国际订单号
            validorderNo: "", //校验国际订单号消息
            enterType: "0",
            disabledone: false,
            disabledtwo: true,
            currentType: "auto", // auto - xiaoI对话  service - 人工对话 wait - 排队 survey 满意度调查 offline 非工作时间
            msgBox: [], // 初始数据;
            inputValue: "", // 发送小小
            selectBox: [], // 快捷操作
            rate: 5, // 当前评价
            subId: -1,
            imgUrl: "", // 预览图片
            isHistory: false,
            isImg: false, // 发送出去的是否是图片类型
            msgId: 0,
            siteCode: "",
            wayBillNo: "", // 运单号
            sessionInfo: {
                source: "",
                openid: "",
                platform: "site"
            },
            msgReBox: [], // 对话数据;
            hotQuestions: [], // 热点问题;
            isActive: false, // 是否可以发送消息;
            quickItems: [] // 快速查询工具
        };
    },
    created() {
        this.getInitData();
    },
    mounted() {
        // 获取开头语
        this.getBeginChat();
        // 获取常见问题列表
        this.initLink();
        // 获取当前状态
        this.getInitStatus();
    },
    methods: {
        // 获取初始化数据
        getInitData() {
            console.log("href:" + location.href);
            console.log("router" + JSON.stringify(this.$route.query));
            let {
                waybillNo = "",
                nodeCode = "",
                platform = "",
                source = "",
                openid = "",
                userid = ""
            } = this.$route.query;
            this.waybillNo = waybillNo;
            this.siteCode = nodeCode;

            platform = common.isEmpty(platform)
                ? window.localStorage.getItem("platform") || "site"
                : platform;
            source = common.isEmpty(source)
                ? window.localStorage.getItem("source") || ""
                : source;
            userid = common.isEmpty(userid)
                ? window.localStorage.getItem("userid") || ""
                : userid;
            if (common.isEmpty(openid)) {
                openid =
                    window.localStorage.getItem("openid") || common.getOpenId();
            }
            window.localStorage.setItem("platform", platform); //平台
            window.localStorage.setItem("openid", openid); //客户标志
            window.localStorage.setItem("source", source); //数据来源
            window.localStorage.setItem("userid", userid); //用户id
            this.sessionInfo = {
                openid: openid || '',
                source: source || '',
                platform: platform || '',
                userid: userid || ''
            };
        },

        // 初始查询状态;
        async getInitStatus() {
            const res = await getStatus(this.sessionInfo || {});
            if (res && res.status == 0) {
                this.currentType = res.data.stage;
                this.subId = res.data.subId;
                if (this.currentType === "survey") {
                    // 打开会话
                    this.closeSession('init');
                } else if (this.currentType === "wait") {
                    // 等待中直接改成服务中，拉取消息
                    this.currentType = "service";
                }

                // 服务中的才获取历史消息
                if (this.currentType === "service") {
                    this.getMessageList();
                    // 拉取人工消息
                    if (!timer) {
                        timer = setInterval(this.getManualMessage, 2000);
                    }
                }
            }
        },
        // 初始查询链接;
        initLink() {
            let data = {
                platform: "wechat"
            };
            getLink(data).then(res => {
                if (res.data && Array.isArray(res.data.items)) {
                    this.selectBox = res.data.items;
                }
                // 快捷操作
                if (res.data.quickReplyTerms) {
                    this.quickItems = res.data.quickReplyTerms.split(";");
                }
            });
        },

        // 跳转其他页面
        goOtherLink(url, icon) {
            const filterObj = {
                yuyue: "order",
                chajian: "track",
                wangdian: "site",
                yunfei: "freight"
            };
            this.fastTrackCount(filterObj[icon], () => {
                location.href = url;
            });
        },

        // 获取xiaoI问题链接
        getXiaoILinks(str) {
            const reg = /\[link.*?\](.*?)\[\/link\]/gi;
            const result = reg.exec(str);
            if (result) {
                const link = result[1].replace(/【(.*)】/, "");
                xiaoIProblemLinks.push(link);
                const newStr = str.substr(result.index + result.length);
                this.getXiaoILinks(newStr);
            } else {
                return;
            }
        },

        // 处理问题
        resolveProblem(index, message) {
            this.msgReBox[index].resolve = message;
            this.sendMsg(message, "RESOLVE");
        },

        // 发送消息;
        async sendMsg(message, type) {
            if (this.inputValue === "" && !message && !this.isImg) {
                return false;
            }
            if (this.inputValue.length >= 350) {
                this.$vux.toast.text("", "bottom");
                return;
            }
            // xiaoI解决问题
            let newMessage = message;
            if (type === "RESOLVE") {
                if (message === "a") {
                    newMessage = "已解决";
                } else {
                    newMessage = "未解决";
                }
            }
            // 非图片类型
            if (!this.isImg) {
                let ibox = {
                    type: 1,
                    imgUrl: "",
                    msgContent: common.formatMsg(
                        message ? newMessage : this.inputValue
                    )
                };
                this.msgReBox.push(ibox);
                if (this.currentType === "auto") {
                    await this.sendXiaoI(message, type);
                } else if (this.currentType === "service") {
                    await this.sendManual(message);
                }
            } else {
                //图片1
                let ibox = {
                    type: 1,
                    imgUrl: message,
                    msgContent: `<img src="${message}" style="max-width: 220px; display: block;"/>`
                };
                this.msgReBox.push(ibox);
                this.isImg = false;
            }
            // 清空输入框
            this.inputValue = "";
            // 滚动到底部
            this.scrollToBottom();
        },

        // 获取xiaoI开头语
        async getBeginChat() {
            let params = {
                action: "BEGINCHAT",
                platform: "weixin", // xiaoI需要写死微信
                userId: ":task:" + this.sessionInfo.openid
            };
            const res = await xiaoChat(params);
            this.msgBox.push(
                this.converXiaoIMessage(res.data.content, res.data.type, true)
            );
        },

        // 发送xiaoI消息
        async sendXiaoI(message) {
            let params = {
                action: "CHATING",
                question: message ? message : this.inputValue,
                platform: this.sessionInfo.platform, // xiaoI需要写死微信
                userId: ":task:" + this.sessionInfo.openid
            };
            // 调用xiaoI
            const res = await xiaoChat(params);
            this.msgReBox.push(
                this.converXiaoIMessage(res.data.content, res.data.type)
            );
        },

        converXiaoIMessage(msgContent, type, isBegin) {
            let msg = {
                type: 0,
                content: "",
                contentType: type,
                msgContent: ""
            };
            // 转人工
            if (msgContent.indexOf("ACS") > -1) {
                msg.contentType = "ACS";
                // 埋点-客户追踪
                this.trackManual();
            } else if (
                msgContent.indexOf("您可能还关注下列问题") > -1 ||
                msgContent.indexOf("以上答案是否解决了您的问题") > -1
            ) {
                let contentIndex = msgContent.indexOf("您可能还关注下列问题");
                xiaoIProblemLinks = [];
                if (contentIndex > -1) {
                    const content = msgContent
                        .substring(0, contentIndex)
                        .replace(/\n/, "");
                    msg.content = common.convertMsg(content);
                    this.getXiaoILinks(msgContent);
                } else {
                    contentIndex = msgContent.indexOf(
                        "以上答案是否解决了您的问题"
                    );
                    const content = msgContent.substring(0, contentIndex);
                    msg.content = common.convertMsg(content);
                }
                msg.contentType = "ANSWER";
                if (!isBegin) {
                    msg.links = xiaoIProblemLinks;
                } else {
                    this.hotQuestions = xiaoIProblemLinks;
                }
            } else {
                msg.msgContent = common.convertMsg(msgContent);
            }
            return msg;
        },

        // 发送人工消息
        async sendManual(message) {
            const res = await postMessage({
                content: message || this.inputValue,
                ...this.sessionInfo,
                subId: this.subId,
                msgId: this.msgId,
                type: "text"
            });
            if (!timer) {
                timer = setInterval(this.getManualMessage, 2000);
            }
            // 如果人工消息是等待中的话，需要返回消息
            if (res.status === 0) {
                if (res.data.stage === "auto") {
                    // 关闭定时器
                    if (timer) {
                        clearInterval(timer), (timer = null);
                    }
                    this.currentType = "auto";
                }

                // 有人工消息直接展示在页面上
                if (res.data.content) {
                    const msgBox = {
                        type: 0,
                        msgContent: res.data.content
                    };
                    this.msgReBox.push(msgBox);
                    this.scrollToBottom();
                }
            }
        },

        // 获取人工消息
        async getManualMessage() {
            const result = await pullMessage({
                ...this.sessionInfo,
                subId: this.subId,
                msgId: this.msgId,
                attr: 'pull-message'
            });
            let msg = {
                type: 0,
                imgUrl: ""
            };
            if (result.status === 0) {
                if (result.data != null) {
                    let pmsg = result.data;
                    // 会话自动关闭
                    if (pmsg.category === "sys_ssncls") {
                        // 客服关闭会话
                        this.currentType = "auto";
                        this.closeSession();
                        return;
                    } else {
                        this.msgId = result.data.msgId;
                        if (
                            result.data != null &&
                            result.data.type === "text"
                        ) {
                            msg.msgContent = common.convertMsg(
                                result.data.text.content
                            );
                            this.msgReBox.push(msg);
                            this.scrollToBottom();
                        } else if (
                            result.data != null &&
                            result.data.type === "image"
                        ) {
                            this.imgUrl =
                                "data:image/png;base64," +
                                result.data.image.pic_url;
                            let ibox = {
                                type: 0,
                                imgUrl: this.imgUrl,
                                msgContent: `<img src="${this.imgUrl}" style="max-width: 220px; display: block;"/>`
                            };
                            this.msgReBox.push(ibox);
                            this.scrollToBottom();
                        }
                    }
                }
            } else {
                console.log("拉取会话失败！");
            }
        },

        // 获取历史消息
        async getMessageList() {
            const msg = await getHistory({
                subId: this.subId,
                ...this.sessionInfo
            });
            if (msg !== null && msg.status === 0) {
                let msgs = msg.data.items;
                if (msgs.length > 0) {
                    this.isHistory = true;
                    for (var i = 0; i < msgs.length; i++) {
                        if (msgs[i].msgId != 0) {
                            const lastMsgId = msgs[i].msgId;
                            this.msgId = lastMsgId || 0;
                        }
                        if (msgs[i].sendAt != null && msgs[i].sendAt != "") {
                            var date = new Date(msgs[i].sendAt);
                            this.lastTime = formatDate(date, "MM月dd日 hh:mm"); //最后之间
                        }
                        if (msgs[i].category === "sys_ssncls") {
                            // 会话关闭
                            // this.closeSession()
                        } else {
                            if (msgs[i].type === "text") {
                                let msg = {
                                    type: 0,
                                    imgUrl: "",
                                    msgContent: common.convertMsg(
                                        msgs[i].msgBody.content
                                    )
                                };
                                if (msgs[i].category === "manreq") {
                                    msg.type = 1;
                                }
                                this.msgReBox.push(msg);
                            } else if (msgs[i].type === "image") {
                                let type = 0;
                                if (msgs[i].category === "manreq") {
                                    type = 1;
                                }
                                this.imgUrl =
                                    "data:image/png;base64," +
                                    msgs[i].msgBody.pic_url;
                                let ibox = {
                                    type: type,
                                    imgUrl: this.imgUrl,
                                    msgContent: `<img src="${this.imgUrl}" style="max-width: 220px; display: block;"/>`
                                };
                                this.msgReBox.push(ibox);
                            }
                        }
                    }
                }
            } else {
                let msg = {
                    type: 0,
                    imgUrl: "",
                    msgContent: common.convertMsg(msg.message)
                };
                this.msgBox.push(ibox);
            }
            this.scrollToBottom();
        },

        // 查看图片
        imgClick(data) {
            if (data === "") {
                return false;
            }
            this.imgUrl = data;
            this.$nextTick(() => {
                this.$refs.picShowDialog.open({
                    type: "pic"
                });
            });
        },

        // 隐藏预览图片
        hideImage() {
            this.$nextTick(() => {
                this.$refs.picShowDialog.close();
            });
        },

        // 选择订单号
        chooseWaybill(waybillNo) {
            this.handleWaybillNo = waybillNo;
            this.getAuth("waybillNo");
        },

        // 获取权限
        async getAuth(type) {
            const res = await authSession({
                ...this.sessionInfo,
                mobile: type === "mobile" ? this.phoneNumber : "",
                waybillNo: type === "waybillNo" ? this.handleWaybillNo : "",
                orderNo: type === "orderNo" ? this.handleorderNo : "",
                siteCode: type === "siteCode" ? this.siteCode : ""
            });
            if (res.status === 0) {
                // 如果超过了运营时间直接展示话术
                if (res.data && res.data.stage === 'offline') {
                    const msgBox = {
                        type: 0,
                        msgContent: res.message
                    };
                    this.msgReBox.push(msgBox);
                    this.scrollToBottom();
                    return;
                }
                this.subId = res.data.subId;
                this.currentType = "service";
                // 重置messageId
                this.msgId = 0;

                // 开启定时
                if (!timer) {
                    timer = setInterval(this.getManualMessage, 2000);
                }
                // 页面显示消息
                if (type == "siteCode") return;
                const ibox = {
                    type: 1,
                    imgUrl: "",
                    msgContent:
                        type === "mobile"
                            ? this.phoneNumber
                            : (type === "waybillNo" ? this.handleWaybillNo : this.handleorderNo)
                };
                this.msgReBox.push(ibox);
            } else {
                const msgBox = {
                    type: 0,
                    msgContent: res.message
                };
                this.msgReBox.push(msgBox);
            }
            this.scrollToBottom();

        },

        // 人工客服点击追踪-埋点
        async trackManual() {
            const result = await trackManual();
        },

        // 快速通道计数
        async fastTrackCount(type, cb) {
            const result = await fastTrackEntranceCount({
                ...this.sessionInfo,
                type: type
            });
            cb && cb()
        },

        // 打开查询订单
        goWayBillNo() {
            if (this.currentType === 'service') {
                return
            }
            // 微信小程序才打开运单列表
            if (this.sessionInfo.userid) {
                this.$nextTick(() => {
                    this.$refs["chooseWaybillNo"].open({
                        type: "bottom"
                    });
                });
            } else {
                this.searchWaybillNo();
            }
        },
        onOpenChooseWaybill() {
            this.$nextTick(() => {
                this.$refs["com-choose-waybill"].init();
            });
        },
        // 关闭查询订单
        closeChooseWaybill() {
            this.$nextTick(() => {
                this.$refs["chooseWaybillNo"].close();
            });
        },
        // 关闭订单列表-打开查询订单
        goSetOrder() {
            this.closeChooseWaybill();
            this.searchWaybillNo();
        },

        // 校验手机号
        toValidPhone(e) {
            const value = e.target.value;
            const reg = constant.mobileRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validPhone = "请输入正确的手机号";
                } else {
                    this.validPhone = "";
                }
            }
        },

        // 校验运单号
        toValidWaybillNo(e) {
            const value = e.target.value;
            const reg = constant.waybillNoRegular();
            if (value) {
                if (!reg.test(value)) {
                    this.validWaybillNo = "请输入正确的运单号";
                } else {
                    this.validWaybillNo = "";
                }
            }
        },

        // 校验国际订单号
        toValidorderNo(e) {
            const value = e.target.value;
            const reg = constant.orderNoRegular();
            if (value) {
                if(!reg.test(value)) {
                    this.validorderNo = "请输入正确的国际订单号";
                } else {
                    this.validorderNo = "";
                }
            }
        },

        // 查询手机号
        goPhone() {
            // 服务中不能点击
            if (this.currentType === 'service') {
                return
            }
            this.phoneNumber = "";
            this.validPhone = "";
            this.$refs["setPhoneDialog"].open({
                title: "请输入手机号",
                type: "confirm",
                confirm: close => {
                    const reg = constant.mobileRegular();
                    if (reg.test(this.phoneNumber)) {
                        this.getAuth("mobile");
                        close && close();
                        this.validPhone = "";
                    } else {
                        this.validPhone = "请输入正确的手机号";
                    }
                }
            });
        },
        changeRadio () {
            if (this.enterType == 0) {
                this.disabledone = false;
                this.disabledtwo = true;
                this.handleorderNo = "";
                this.validorderNo = "";
            }
            if (this.enterType == 1) {
                this.disabledone = true;
                this.disabledtwo = false;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
            }
            if (this.enterType == 2) {
                this.disabledone = true;
                this.disabledtwo = true;
                this.handleWaybillNo = "";
                this.validWaybillNo = "";
                this.handleorderNo = "";
                this.validorderNo = "";
            }
        },
        // 查询国际订单号
        goorderNo () {
            if(this.currentType === 'service') {
                return;
            }
            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.handleorderNo = "";
            this.validorderNo = "";
            this.$refs["setorderNo"].open({
                title: "请选择进入方式",
                type: "confirm",
                confirm: close => {
                    console.log('enterType-->', this.enterType);
                    if (this.enterType == 0) {
                        const reg = constant.waybillNoRegular();
                        if (reg.test(this.handleWaybillNo)) {
                            this.getAuth("waybillNo");
                            this.validWaybillNo = "";
                            close && close();
                        } else {
                            this.validWaybillNo = "请输入正确的运单号";
                        }
                    }
                    if (this.enterType == 1) {
                        const reg = constant.orderNoRegular();
                        if (reg.test(this.handleorderNo)) {
                            this.getAuth("orderNo");
                            this.validorderNo = "";
                            close && close();
                        } else {
                            this.validorderNo = "请输入正确的国际订单号";
                        }
                    }
                    if (this.enterType == 2) {
                        this.siteCode = "999995";
                        this.getAuth("siteCode");
                        close && close();
                    }
                }
            })
        },
        // 查询运单号
        searchWaybillNo() {
            this.handleWaybillNo = "";
            this.validWaybillNo = "";
            this.$refs["setWaybillNo"].open({
                title: "请输入单号",
                type: "confirm",
                confirm: close => {
                    const reg = constant.waybillNoRegular();
                    if (reg.test(this.handleWaybillNo)) {
                        this.getAuth("waybillNo");
                        this.validWaybillNo = "";
                        close && close();
                    } else {
                        this.validWaybillNo = "请输入正确的运单号";
                    }
                }
            });
        },
        // 滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                const innerBox = this.$refs.xwBody;
                console.log("start:" + innerBox.scrollTop);
                if (innerBox.scrollHeight > innerBox.clientHeight) {
                    setTimeout(() => {
                        //设置滚动条到最底部
                        innerBox.scrollTop = innerBox.scrollHeight;
                        innerBox.style.opacity = 1;
                        console.log("end:" + innerBox.scrollTop);
                    }, 50);
                }
            });
        },

        // 关闭会话
        closeSession(type) {
            this.$nextTick(() => {
                this.$refs["rateDialog"].open({
                    title: "服务评价",
                    type: "confirm",
                    confirm: close => {
                        closeSession({
                            ...this.sessionInfo,
                            survey: this.rate
                        }).then(res => {
                            if (res.status === 0) {
                                // this.$vux.toast.text('评价成功', 'bottom');
                                // 关闭人工消息
                                const ibox = {
                                    type: 0,
                                    imgUrl: "",
                                    msgContent:
                                        "亲，谢谢您的肯定，祝您生活愉快！"
                                };
                                this.msgReBox.push(ibox);
                                this.scrollToBottom();
                                this.currentType = "auto";
                                if (timer) {
                                    clearInterval(timer);
                                    timer = null;
                                }
                                close && close();
                            } else {
                                this.$vux.toast.text(res.message, "bottom");
                            }
                        });
                    },
                    cancel: close => {
                        // 如果当前是初始化状态，获取的评价调查状态
                        // 当用户点击取消的时候，需要调用关闭评价状态-默认给5星，并改成xiaoI会话状态
                        if (type === 'init') {
                             closeSession({
                                ...this.sessionInfo,
                                survey: 5
                            });
                            this.currentType = 'auto';
                        }
                        close && close();
                    }
                });
            });
        },
        // 上传图片
        upload(e) {
            if (!this.currentType === "auto") {
                this.$vux.toast.text("机器人模式不能发送图片消息！", "bottom");
                return;
            }
            let files = e.target.files || e.dataTransfer.files;
            if (
                !(
                    files[0].type === "image/png" ||
                    files[0].type === "image/jpeg"
                )
            ) {
                this.$vux.toast.text("亲，只支持图片上传！", "bottom");
                return;
            }
            if (files.length < 1) {
                this.$vux.toast.text("请寻找需要上传的图片！", "bottom");
                return;
            }
            this.isImg = true;
            this.imgPreview(files[0]);
        },

        imgPreview(file) {
            let self = this;
            let Orientation = 0;
            //去获取拍照时的信息，解决拍出来的照片旋转问题
            // EXIF.getData(file, function(){
            //     Orientation=EXIF.getTag(this, 'Orientation');
            // });
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return;
            if (/^image/.test(file.type)) {
                // 创建一个reader
                let reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file);
                // 读取成功后的回调
                reader.onloadend = async function() {
                    let result = this.result;
                    if (result !== "null" && result !== null) {
                        let img = new Image();
                        img.src = result;
                        let senddata = {
                            ...self.sessionInfo,
                            type: "image"
                        };
                        let config = {
                            headers: { "Content-Type": "application/json" }
                        };
                        //判断图片是否大于1M,是就直接上传，反s之压缩图片2
                        if (this.result.length <= 1024 * 1024) {
                            setTimeout(async function() {
                                let data = self.compress(img, Orientation);
                                var index = data.indexOf("base64") + 7;
                                senddata.imgData = data.substr(index);
                                let res = await postMessage(senddata);
                                if (res.status === 0) {
                                    self.sendMsg(data);
                                    return;
                                } else {
                                    self.showPositionValue = true;
                                    self.toastText = "上传图片失败";
                                    return;
                                }
                            }, 500);
                        } else {
                            img.onload = async function() {
                                setTimeout(async function() {
                                    let data = self.compress(img, Orientation);
                                    var index = data.indexOf("base64") + 7;
                                    senddata.imgData = data.substr(index);
                                    let res = await postMessage(senddata);
                                    if (res.status === 0) {
                                        self.sendMsg(data);
                                        return;
                                    } else {
                                        self.showPositionValue = true;
                                        self.toastText = "上传图片失败";
                                        return;
                                    }
                                }, 500);
                            };
                        }
                    }
                };
            }
        },
        rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            const min_step = 0;
            const max_step = 3;
            if (img == null) return;
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            let height = img.height;
            let width = img.width;
            let step = 2;
            if (step == null) {
                step = min_step;
            }
            if (direction == "right") {
                step++;
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step);
            } else {
                step--;
                step < min_step && (step = max_step);
            }
            //旋转角度以弧度值为参数
            let degree = (step * 90 * Math.PI) / 180;
            let ctx = canvas.getContext("2d");
            switch (step) {
                case 0:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0);
                    break;
                case 1:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, 0, -height);
                    break;
                case 2:
                    canvas.width = width;
                    canvas.height = height;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, -height);
                    break;
                case 3:
                    canvas.width = height;
                    canvas.height = width;
                    ctx.rotate(degree);
                    ctx.drawImage(img, -width, 0);
                    break;
            }
        },
        compress(img, Orientation) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            //瓦片canvas
            let tCanvas = document.createElement("canvas");
            let tctx = tCanvas.getContext("2d");
            let initSize = img.src.length;
            let width = img.width;
            let height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            let ratio;
            if ((ratio = (width * height) / 4000000) > 1) {
                /* console.log("大于400万像素")*/
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //        铺底色
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            let count;
            if ((count = (width * height) / 1000000) > 1) {
                /*   console.log("超过100W像素");*/
                count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                //            计算每块瓦片的宽和高
                let nw = ~~(width / count);
                let nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (let i = 0; i < count; i++) {
                    for (let j = 0; j < count; j++) {
                        tctx.drawImage(
                            img,
                            i * nw * ratio,
                            j * nh * ratio,
                            nw * ratio,
                            nh * ratio,
                            0,
                            0,
                            nw,
                            nh
                        );
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != "" && Orientation != 1) {
                switch (Orientation) {
                    case 6: //需要顺时针（向左）90度旋转
                        this.rotateImg(img, "left", canvas);
                        break;
                    case 8: //需要逆时针（向右）90度旋转
                        this.rotateImg(img, "right", canvas);
                        break;
                    case 3: //需要180度旋转
                        this.rotateImg(img, "right", canvas); //转两次
                        this.rotateImg(img, "right", canvas);
                        break;
                }
            }
            //进行最小压缩
            let ndata = canvas.toDataURL("image/jpeg", 0.4);
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            return ndata;
        },
        // 改变评价
        changeRate(value) {
            this.rate = value;
        }
    },
    destroyed() {
        // 关闭定时器
        if (timer) {
            clearInterval(timer), (timer = null);
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/xiaoI/chat.vue